import { isDesktop } from '../constants/devices.constants';
import { getElementOrParentByClassName } from '../helpers/utils';
import { showModal } from '../services/dialog.service';
const FLIP_IMAGE_CLASS = 'boost-pfs-filter-product-item-flip-image';
const MAIN_IMAGE_SELECTOR = '.boost-pfs-filter-product-item-main-image';
const IMAGE_LINK_SELECTOR = '.boost-pfs-filter-product-item-image-link';
const IMG_PLACEHOLDER = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
class ProductCard extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click', async (e) => {
            const target = e.target;
            const waitlistTrigger = getElementOrParentByClassName(target, 'js-trigger-bis');
            if (waitlistTrigger) {
                const waitlistFormEl = document.createElement('waitlist-form');
                waitlistFormEl.setAttribute('variantId', waitlistTrigger.dataset.variantId);
                waitlistFormEl.setAttribute('productId', waitlistTrigger.dataset.productId);
                waitlistFormEl.setAttribute('title', "We’ll notify you as soon as this item is available.");
                showModal([waitlistFormEl]);
            }
        });
    }
    connectedCallback() {
        if (this.isBoostFilterManaged()) {
            return;
        }
        this.hydrateLazyImages();
        this.initImageSwap();
    }
    /**
     * Boost init.js runs on every page, but swapImage lives in boost-pfs-filter.js
     * which only loads on Boost-managed collection pages.
     */
    isBoostFilterManaged() {
        return typeof window.boostSwapImage === 'function';
    }
    hydrateLazyImages() {
        this.querySelectorAll('img[data-src]').forEach((img) => {
            if (img.dataset.src) {
                img.src = img.dataset.src;
            }
            if (img.dataset.srcset) {
                img.srcset = img.dataset.srcset;
            }
            img.removeAttribute('data-srcset');
            img.removeAttribute('data-src');
        });
    }
    initImageSwap() {
        if (!isDesktop() || !this.querySelector('.has-bc-swap-image')) {
            return;
        }
        const mainImage = this.querySelector(`${MAIN_IMAGE_SELECTOR}[data-img-flip-src]`);
        if (!mainImage) {
            return;
        }
        const imageLink = mainImage.closest(IMAGE_LINK_SELECTOR);
        if (!imageLink || imageLink.querySelector(`.${FLIP_IMAGE_CLASS}`)) {
            return;
        }
        const flipSrc = mainImage.dataset.imgFlipSrc;
        if (!flipSrc) {
            return;
        }
        const flipImage = document.createElement('img');
        flipImage.className = `${FLIP_IMAGE_CLASS} lazyload Image--lazyLoad`;
        flipImage.alt = mainImage.alt;
        flipImage.src = IMG_PLACEHOLDER;
        flipImage.dataset.sizes = mainImage.dataset.sizes || 'auto';
        if (mainImage.dataset.widths) {
            flipImage.dataset.widths = mainImage.dataset.widths;
        }
        const flipSrcset = mainImage.dataset.imgFlipSrcset;
        if (flipSrcset) {
            flipImage.srcset = flipSrcset;
        }
        flipImage.src = flipSrc;
        imageLink.appendChild(flipImage);
    }
}
if (!window.customElements.get('product-card')) {
    customElements.define('product-card', ProductCard);
}
